import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import AdminDataTable from "../../components/common/AdminDataTable";
import { buklEmailColumns } from "../../tables/buklEmailColumns";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { bulkSMSColumns } from "../../tables/bulkSMSColumns";
import { can } from "../../utils/can";

export default function BulkEmail() {
  const PAGE_SIZE = 10;

  const [history, setHistory] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [message, setMessage] = useState("");
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const [form, setForm] = useState({
    sendTo: "",
    content: "",
  });

  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});

  const token = localStorage.getItem("adminToken");
  const API_URL = process.env.REACT_APP_BASE_URL_API;

  /* ================= VALIDATION ================= */
  const validate = () => {
    const err = {};
    if (!form.sendTo) err.sendTo = "Required";
    if (!form.content || form.content.length < 10)
      err.content = "Minimum 10 characters required";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  /* ================= FETCH LIST ================= */
  const fetchSMS = async (pageNo = 1) => {
    try {
      setListLoading(true);

      const res = await fetch(
        `${API_URL}/api/admin/bulk/sms-list?page=${pageNo}&limit=${PAGE_SIZE}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const json = await res.json();

      setHistory(json.data || []);
      setTotalPages(json.totalPages || 1);
      setPage(pageNo);
    } catch (err) {
      console.error("Fetch error", err);
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    fetchSMS(page);
  }, []);

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    if (can("bulk_sms", "create") === false) {
      alert("You don't have permission to perform this action.");
      return;
    }

    try {
      const url = editId
        ? `${API_URL}/api/admin/bulk/sms-list/update/${editId}`
        : `${API_URL}/api/admin/bulk/sms-create`;

      const method = "POST";

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(form),
      });

      const result = await response.json();

      if (response.ok) {
        resetForm();
        fetchSMS(page);
        setMessage(result.message);
      } else {
        setMessage(result.message);
      }

    } catch (err) {
      console.error("Submit error", err);
    }
  };

  /* ================= EDIT ================= */
  const handleEdit = (row) => {
    if (can("bulk_sms", "edit") === false) {
      alert("You don't have permission to perform this action.");
      return;
    }

    setEditId(row._id);
    setForm({
      sendTo: row.sendTo,
      content: row.content,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (can("bulk_sms", "delete") === false) {
      alert("You don't have permission to perform this action.");
      return;
    }

    if (!window.confirm("Delete this record?")) return;

    try {
      await fetch(`${API_URL}/api/admin/bulk/sms-list/delete/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      fetchSMS(page);
    } catch (err) {
      console.error("Delete error", err);
    }
  };

  const resetForm = () => {
    setEditId(null);
    setForm({ sendTo: "", content: "" });
    setErrors({});
  };

  const columns = bulkSMSColumns(handleEdit, handleDelete, PAGE_SIZE);

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Bulk SMS" />

        <div className="right_col" role="main">
         

          {/* ================= FORM ================= */}
          <div className="x_panel">
            <h2>{editId ? "Edit Bulk SMS" : "Bulk SMS Form"}</h2>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label>Send To</label>
                <select
                  className="form-select"
                  value={form.sendTo}
                  onChange={(e) =>
                    setForm({ ...form, sendTo: e.target.value })
                  }
                >
                  <option value="">Select</option>
                  <option value="All Members">All Members</option>
                  <option value="Paid Members">Paid Members</option>
                  <option value="Unpaid Members">Unpaid Members</option>
                </select>
                {errors.sendTo && (
                  <p className="text-danger">{errors.sendTo}</p>
                )}
              </div>


              <div className="mb-3">
                <label>Message</label>

                <CKEditor
                  editor={ClassicEditor}
                  data={form.content}
                  onChange={(event, editor) => {
                    const data = editor.getData();

                    setForm((prev) => ({
                      ...prev,
                      content: data,
                    }));

                    // live validation clear
                    if (data && data.length >= 10) {
                      setErrors((prev) => ({ ...prev, content: "" }));
                    }
                  }}
                  onBlur={() => {
                    if (!form.content || form.content.length < 10) {
                      setErrors((prev) => ({
                        ...prev,
                        content: "Minimum 10 characters required",
                      }));
                    }
                  }}
                />

                {errors.content && (
                  <p className="text-danger">{errors.content}</p>
                )}
              </div>


              <button className="btn sitebtn">
                {editId ? "Update" : "Submit"}
              </button>

              {/* {editId && (
                <button
                  type="button"
                  className="btn btn-secondary ml-2"
                  onClick={resetForm}
                >
                  Cancel
                </button>
              )} */}
              <p className="text-success">{message}</p>
            </form>
          </div>

          {/* ================= LIST ================= */}
          <div className="x_panel">
            <h2>Bulk Email List</h2>

            <AdminDataTable
              columns={columns}
              data={history}
              loading={listLoading}
              page={page}
              totalPages={totalPages}
              loading={listLoading}
              onPageChange={setPage}
              onPageSizeChange={(size) => {
                setPageSize(size);
                setPage(1);
                fetchSMS(1, size);
              }}
              sortBy={sortBy}
              sortOrder={sortOrder}
            />
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
